import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { hideNotification } from 'store/actions/uiActions' ;

function getStyles(context) {
    if (!context) {
        return {
            accent1Color: '#ff4081',
            primary1Color: '#00bcd4',
        };
    }

    const {
        muiTheme: {
            baseTheme: {
                palette: {
                    accent1Color,
                    primary1Color,
                },
            },
        },
    } = context;

    return {
        accent1Color: accent1Color,
        primary1Color: primary1Color,
    };
}

const Notification = (props, context) => {
    const style = {};
    const { primary1Color, accent1Color } = getStyles(context);
    const { type, translate, message } = props;

    if (type === 'warning') {
        style.backgroundColor = accent1Color;
    }

    if (type === 'confirm') {
        style.backgroundColor = primary1Color;
    }

    return <Snackbar
        autoHideDuration={ 4000 }
        bodyStyle={ style }
        message={ !!message && translate(message) }
        onRequestClose={ () => {
            props.hide();
        } }
        open={ !!message }
    />;
};

Notification.propTypes = {
    hide: PropTypes.func.isRequired,
    message: PropTypes.string,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

Notification.defaultProps = {
    type: 'info',
};

Notification.contextTypes = {
    muiTheme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        message: state.notification.text,
        type: state.notification.type,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hide: () => {
            dispatch(hideNotification());
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(Notification);



// WEBPACK FOOTER //
// ./src/components/notifications/Notification.js